import { queryClient } from "~/plugins/vue-query";
import { journalService } from "~/utils/api/journalService";

export default defineNuxtRouteMiddleware(async (to) => {
  queryClient.fetchQuery({
    queryKey: ["journal", to.params.id],
    queryFn: () =>
      journalService.getJournal({
        id: Number(to.params.id),
        with: ["author"],
      }),
  });
});
